import React, { useState, useEffect, SyntheticEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { connect } from 'react-redux';
import Navbar from '../Navbar';
import RegionesYcomunas from '../RegisterForm/regionesComunas';
import { productsAndServices } from '../../const/productsAndServices';
import { PerfilTypes } from '../../Types/PerfilTypes';
import './editService.css';
import Footer from '../Footer';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

function mapStateToProps (state: any) {
  return { action: state }; // this will be available in HomeScreen as props.action
}

function EditService (props: PerfilTypes) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [region, setRegion] = useState('');
  const [commune, setCommune] = useState('');
  const [address, setAddress] = useState('');
  const [category, setCategory] = useState('');
  const [phone, setPhone] = useState('');
  const [link, setLink] = useState('');
  const [imageUrl, setImageUrl] = useState('');

  const [comunas, setComunas] = useState<Array<string>>([]);

  const productsCategories = Object.values(productsAndServices.products).map((product) => product.category);
  const servicesCategories = Object.values(productsAndServices.services).map((service) => service.category);
  const allCategories = [...new Set([...productsCategories, ...servicesCategories])].sort();
  const [verification, setVerification] = useState(false);
  const navigate = useNavigate();

  async function getDefaultData() {
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.get(process.env.REACT_APP_URL + '/services/' + getServiceId(), { headers: { Authorization: 'Bearer ' + token } })
      .then((response) => {
        setName(response.data.service[0].name);
        setDescription(response.data.service[0].description);
        setRegion(response.data.service[0].addressRegion);
        Object.values(RegionesYcomunas)[0].forEach(reg => {
          if (reg.NombreRegion === response.data.service[0].addressRegion) {
            setComunas(reg.comunas);
          }
        });
        setCommune(response.data.service[0].addressComuna);
        setAddress(response.data.service[0].address);
        setCategory(response.data.service[0].platformCat);
        setPhone(response.data.service[0].phone);
        setLink(response.data.service[0].link);
        setImageUrl(response.data.service[0].profileUrlImg);
      });

    if (props.action.user.credenciales.rol === 2) {
      await axios.get(process.env.REACT_APP_URL + '/vets/' + props.action.user.credenciales.id, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data.vet.verified_status === 'verified') {
            setVerification(true);
          }
        });
    }
  }

  function getServiceId() {
    return window.location.pathname.split('/')[3];
  }

  function handleRegion(event: SyntheticEvent) {
    event.preventDefault();
    const currentRegion = (event.target as HTMLInputElement).value;
    setRegion(currentRegion);
    Object.values(RegionesYcomunas)[0].forEach(reg => {
      if (reg.NombreRegion === currentRegion) {
        setComunas(reg.comunas);
        setCommune(reg.comunas[0]);
      }
    });
  };

  function handleCategory(event: SyntheticEvent) {
    const target = event.target as HTMLInputElement;
    setCategory(target.value);
  }

  async function volver () {
    if (props.action.user.credenciales.isvet === 'NO') {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  };

  async function deleteService(event: SyntheticEvent) {
    event.preventDefault();
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.delete(process.env.REACT_APP_URL + '/services/' + getServiceId(), { headers: { Authorization: 'Bearer ' + token } });
    if (!verification) {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  }

  async function handleSubmit(event: SyntheticEvent) {
    event.preventDefault();
    const token = JSON.parse(localStorage.getItem('token') || '');
    await axios.patch(process.env.REACT_APP_URL + '/services/' + getServiceId(), { name, description, addressRegion: region, addressComuna: commune, address, platformCat: category, phone, link, profileUrlImg: imageUrl }, { headers: { Authorization: 'Bearer ' + token } });
    if (!verification) {
      navigate('/perfil/' + props.action.user.credenciales.id);
    } else {
      navigate('/perfilVet/' + props.action.user.credenciales.id);
    }
  }

  function convertToBase64(file: any) {
    return new Promise(resolve => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        resolve(reader.result);
      };
    });
  };

  async function onFileChange(event: any) {
    event.preventDefault();
    const convertedFile = await convertToBase64(event.target.files[0]);
    setImageUrl(String(convertedFile));
  };

  useEffect(() => {
    getDefaultData();
  }, []);

  return (
    <>
      <Navbar logged={true}/>
      <div className='form-container'>
        <div className='title'>Editar servicio</div>
        <form onSubmit={handleSubmit}>
          <div className='field-container'>
            <input className='register-form-input' name="name" onChange={(e) => setName(e.target.value)} value={name} required/>
            <label className="edit-profile-label" htmlFor="name">Nombre del Servicio</label>
          </div>
          <div className='field-container'>
            <input className='register-form-input' name="description" onChange={(e) => setDescription(e.target.value)} value={description} />
            <label className="edit-profile-label" htmlFor="description">Descripción</label>
          </div>
          <div className='field-container'>
            <select className="box-campo" id="region" name="region" value={region} onChange={(e) => handleRegion(e)} required>
              <option value="" defaultValue="" disabled hidden>Región</option>
              {Object.values(RegionesYcomunas)[0].map((region) => {
                return <option key={region.NombreRegion}>{region.NombreRegion}</option>;
              })}
            </select>
            <label className="edit-profile-label" htmlFor="region">Región</label>
          </div>
          <div className='field-container'>
            <select className="box-campo" id="commune" name="commune" value={commune} onChange={(e) => setCommune(e.target.value)} required>
              <option value="" defaultValue="" disabled hidden>Comuna</option>
              {comunas.map((comuna) => (<option key={comuna}>{comuna}</option>))}
            </select>
            <label className="edit-profile-label" htmlFor="commune">Comuna</label>
          </div>
          <div className='field-container'>
            <input className='register-form-input' id="address" name="address" onChange={(e) => setAddress(e.target.value)} value={address}></input>
            <label className="edit-profile-label" htmlFor="address">Dirección</label>
          </div>
          <div className='field-container'>
            <select className="box-campo" id="category" name="category" value={category} onChange={handleCategory} required>
              <option value="" defaultValue="" disabled hidden>Categoría</option>
              {allCategories.map((category, index) => (<option key={index} value={category}>{category}</option>))}
            </select>
            <label className="edit-profile-label" htmlFor="category">Categoría</label>
          </div>
          <div className='field-container'>
            <input className='register-form-input' id="phone" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required/>
            <label className="edit-profile-label" htmlFor="phone">Teléfono (+56 y 9 dígitos)</label>
          </div>
          <div className='field-container'>
            <input className='register-form-input' id="link" name="link" value={link} onChange={(e) => setLink(e.target.value)}></input>
            <label className="edit-profile-label" htmlFor='link'>Link</label>
          </div>
          <p style={{ display: 'flex', justifyContent: 'center', marginTop: '40px' }}>
                            <label htmlFor="profileUrlImg" className="upload-label">
                              Cambiar foto
                              <input
                                className="register-form-input"
                                type="file"
                                onChange={onFileChange}
                                name="profileUrlImg"
                                id="profileUrlImg"
                              />
                              <CloudUploadIcon className="upload-icon" />
                            </label>
                          </p>
          <div className='upload-button-container'>
            <button className="save-button" onClick={volver}> Volver </button>
            <button className="save-button" value="submit"> Guardar </button>
            <button className="delete-button" onClick={deleteService}> Eliminar </button>
          </div>
        </form>
      </div>
      <Footer/>
    </>
  );
};

export default connect(mapStateToProps)(EditService);
